<template>
  <div class="container my-1" id="telaPrincipal">
    <b-row class="mb-2 no-print">
      <b-col lg="12">
        <div class="text-center" v-if="carregando">
          <b-spinner variant="warning"></b-spinner>
        </div>
      </b-col>
    </b-row>
    <!-- /// mensagens de sucesso / erro -->
    <div
      :v-if="mensagemSucesso"
      v-for="i in mensagemSucesso"
      :key="i"
      class="no-print"
    >
      <p>
        <b-alert show variant="success" dismissible>{{ i }}</b-alert>
      </p>
    </div>
    <div :v-if="mensagemErro" v-for="i in mensagemErro" :key="i">
      <p>
        <b-alert show variant="danger" dismissible>
          <b-icon variant="danger" icon="x-circle-fill" />
          {{ i }}
        </b-alert>
      </p>
    </div>
    <!-- /// mensagens de sucesso / erro -->

    <!-- tela nova postagem / consulta -->
    <div class="mt-0">
      <b-row class="mb-2">
        <b-col lg="4" class="mr-5">
          <h2 class="title"></h2>
        </b-col>
        <b-col lg="4" class="ml-4"> </b-col>
        <b-col lg="3" class="mt-4">
          <div v-if="exibirBtnNovaFaixaPostagem">
            <span id="novaFaixaPostagem" class="float-right" tabindex="0">
              <b-button
                variant="success"
                class="btn float-right no-print"
                :disabled="!permissaoAcesso"
                @click.prevent="novaFaixaPostagem()"
              >
                NOVA FAIXA
              </b-button>
            </span>
            <b-tooltip v-if="!permissaoAcesso" target="novaFaixaPostagem"
              >Usuário não tem permissão para executar esta função.
            </b-tooltip>
          </div>
        </b-col>
      </b-row>

      <b-card class="mb-3" v-if="exibeCadastrarNovaFaixa">
        <b-row>
          <b-col lg="5">
            <h3 class="title mt-0 print-width-100">Cadastrar nova faixa</h3>
          </b-col>
          <b-col lg="5" class="mr-4"> </b-col>
        </b-row>
        <div>
          <span style="font-size: 13px">Os campos com asterisco ( </span>
          <span class="font-weight-bold" style="font-size: 20px; color: red"
            >*</span
          >
          <span style="font-size: 13px">
            ) são de preenchimento obrigatório.</span
          >
        </div>
        <b-row class="my-3 mb-2">
          <b-col sm="5" md="3" lg="6">
            <label for="franqueada" class="p-0 mb-03">Franqueada </label>
            <b-form-select
              id="franqueada"
              v-model="postagem.idfranqueada"
              :options="opcoesFranqueadas"
              disabled
            >
            </b-form-select>
          </b-col>
        </b-row>

        <b-row class="mb-0">
          <b-col sm="2" md="2" lg="1" align-self="center">
            <label for="numInicial" class="mt-0"
              >Numeração Inicial
              <i
                class="ml-0 font-weight-bold"
                style="color: red; font-size: 20px"
              >
                *
              </i>
            </label>
          </b-col>
          <b-col sm="2" md="2" align-self="start">
            <b-form-input
              id="numInicial"
              class="ml-3 mt-1"
              type="search"
              v-mask="['############']"
              v-model="postagem.numeracaoInicial"
            >
            </b-form-input>
            <small id="cpfCnpj" class="form-text" align="right">
              ( sem DV )
            </small>
          </b-col>
          <b-col sm="2" md="2" lg="1" align-self="center" class="ml-5">
            <label for="numInicial" class="mt-0"
              >Numeração Final
              <i
                class="ml-0 font-weight-bold"
                style="color: red; font-size: 20px"
              >
                *
              </i>
            </label>
          </b-col>
          <b-col sm="2" md="2" align-self="start">
            <b-form-input
              id="numInicial"
              class="ml-3 mt-1"
              type="search"
              v-mask="['############']"
              v-model="postagem.numeracaoFinal"
              @keyup="preencheNumDisponivel()"
              @blur="calculaQuantidade()"
            >
            </b-form-input>
            <small id="cpfCnpj" class="form-text" align="right">
              ( sem DV )
            </small>
          </b-col>
          <b-col sm="2" md="2" lg="1" align-self="center" class="ml-5">
            <label for="numInicial" class="mt-0">Quantidade</label>
          </b-col>
          <b-col sm="2" md="2" align-self="start">
            <b-form-input
              id="numInicial"
              class="ml-3 mt-1"
              type="search"
              v-mask="['############']"
              disabled
              v-model="quantidade"
            >
            </b-form-input>
          </b-col>
        </b-row>

        <b-row class="mb-0">
          <b-col sm="2" md="2" lg="1" align-self="center">
            <label for="idValidade" class="mt-0"
              >Validade ( dias )
              <i
                class="ml-0 font-weight-bold"
                style="color: red; font-size: 20px"
              >
                *
              </i>
            </label>
          </b-col>
          <b-col sm="2" md="2" align-self="start" class="mr-2">
            <b-form-input
              id="idValidade"
              class="ml-3 mt-1"
              type="search"
              v-mask="['###']"
              v-model="validade"
              @keyup="calculaDataValidade(validade, 'idDataValidade')"
            >
            </b-form-input>
          </b-col>
          <b-col sm="1" md="1" lg="1" align-self="start" class="ml-4 mr-2">
            <label for="idDataValidade" class="ml-3">Data de Validade </label>
          </b-col>
          <b-col sm="2" md="2" align-self="start" class="ml-4 mt-1 mr-0">
            <b-form-input
              id="idDataValidade"
              v-model="postagem.dataValidade"
              type="date"
              disabled
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="mb-0">
          <b-col sm="2" md="2" lg="1" align-self="center">
            <label for="numInicial" class="mt-0">Numeração Disponível</label>
          </b-col>
          <b-col sm="2" md="2" align-self="start">
            <b-form-input
              id="numInicial"
              class="ml-3 mt-1"
              type="search"
              v-mask="['############']"
              v-model="postagem.numeracaoDisponivel"
              disabled
            >
            </b-form-input>
          </b-col>
        </b-row>

        <b-row class="mb-0">
          <b-col sm="2" md="2" lg="1" align-self="center">
            <label for="tipoFaixa" class="mt-0">Tipo Faixa</label>
          </b-col>
          <b-col sm="2" md="2" align-self="start">
            <b-form-input
              id="tipoFaixa"
              class="ml-3 mt-1"
              type="search"
              v-model="postagem.tipoFaixa"
              disabled
            >
            </b-form-input>
          </b-col>
        </b-row>

        <b-row class="mb-0">
          <b-col sm="2" md="2" lg="1" align-self="center">
            <label for="codFacAR" class="mt-0"
              >Tipo Postal
              <i
                class="ml-0 font-weight-bold"
                style="color: red; font-size: 20px"
              >
                *
              </i>
            </label>
          </b-col>
          <b-col sm="2" md="2" align-self="start">
            <b-form-input
              id="codFacAR"
              class="ml-3 mt-1"
              type="search"
              v-model="postagem.codFacAR"
              @input="postagem.codFacAR = postagem.codFacAR.toUpperCase()"
              v-mask="['AAA']"
            >
            </b-form-input>
          </b-col>
        </b-row>

        <b-row class="mb-0">
          <b-col sm="2" md="2" lg="1" align-self="center">
            <label for="tipoFac" class="mt-0">Tipo FAC</label>
          </b-col>
          <b-col sm="2" md="2" align-self="start">
            <b-form-input
              id="tipoFac"
              class="ml-3 mt-1"
              type="search"
              v-model="postagem.tipoFac"
              disabled
            >
            </b-form-input>
          </b-col>
        </b-row>

        <div class="mt-5">
          <b-button
            id="salvarDados"
            variant="success"
            class="btn ml-2 float-right"
            @click.prevent="salvarInclusao()"
            :disabled="verificaPreenchimento()"
          >
            SALVAR
            <b-tooltip target="salvarDados" placement="bottom">
              Confirmar a inclusão
            </b-tooltip>
          </b-button>

          <b-button
            variant="secondary"
            id="cancelarEdicao1"
            class="ml-2 float-right"
            @click.prevent="abrirModal('modal-cancelar-atualizacao')"
          >
            CANCELAR
            <b-tooltip target="cancelarEdicao1" placement="bottom">
              Cancelar operação
            </b-tooltip>
          </b-button>
        </div>
      </b-card>

      <!-- confirmar atualizações    -->
      <b-modal
        ref="modal-salvar-atualizacao"
        hide-footer
        title="Confirma Inclusão?"
        body-text-variant="danger"
        size="xl"
        centered
        modal-class="small-modal"
      >
        <b-button-group class="w-100 mt-3">
          <b-button
            @click="sairModalAtualizacao()"
            colspan="6"
            variant="outline-secondary "
          >
            Não
          </b-button>
          <b-button
            colspan="6"
            variant="success"
            class="ml-2"
            @click="persistirDados()"
            >Sim</b-button
          >
        </b-button-group>
      </b-modal>
      <!-- fim - confirmar atualizações    -->

      <!-- confirmar cancelamento    -->
      <b-modal
        ref="modal-cancelar-atualizacao"
        hide-footer
        title="Cancelar a operação?"
        size="xl"
        centered
        modal-class="small-modal"
      >
        <b-button-group class="w-100 mt-3">
          <b-button
            colspan="6"
            variant="outline-secondary "
            @click="desfazerCancelar()"
          >
            Não
          </b-button>
          <b-button colspan="6" class="ml-2" @click="sairModalCancelamento()"
            >Sim</b-button
          >
        </b-button-group>
      </b-modal>
      <!-- fim - confirmar cancelamento   -->
    </div>
    <!-- tela nova postagem / consulta -->

    <!-- exibir postagem -->
    <div v-if="exibeHistoricoPostagem">
      <h2 class="title mt-5">Histórico faixa fac AR</h2>
      <b-card class="mb-0">
        <tabelaPostagemFaixaAR
          responsive="xl"
          class="text-right"
          :items="listaPostagemFaixa"
          :fields="cabecalhoPostagemFaixa"
        />
      </b-card>
    </div>
    <!-- debitos selecionados-->
  </div>
</template>     

<script>
import { mask } from "vue-the-mask";
import "vue-loading-overlay/dist/vue-loading.css";
import tabelaPostagemFaixaAR from "../components/tabelaPostagemFaixaAR.vue";
import constantes from "../constants/index";
import moment from "moment";
import normalizaMensagemApi from '../helpers/normalizaMensagemApi';

export default {
  components: {
    tabelaPostagemFaixaAR,
  },
  directives: {
    mask,
  },
  data() {
    return {
      persistiuOK: false,
      mensagemSucesso: [],
      mensagemErro: [],
      carregando: false,
      permissaoAcesso: true,
      exibeHistoricoPostagem: false,
      exibeCadastrarNovaFaixa: false,
      listaPostagemFaixa: [],
      exibirBtnNovaFaixaPostagem: false,
      opcoesFranqueadas: [],
      quantidade: "",
      postagem: {
        idfranqueada: "",
        tipoFaixa: "Local",
        numeracaoInicial: "",
        numeracaoFinal: "",
        numeracaoDisponivel: "",
        dataInclusao: "",
        dataValidade: "",
        codFacAR: "FF",
        tipoFac: "D",
      },
      validade: "",
      cabecalhoPostagemFaixa: [
        {
          label: "Franqueada",
          key: "DESCRICAO",
        },
        {
          label: "Tipo Faixa",
          key: "TIPO_FAIXA",
        },
        {
          label: "Numeração Inicial",
          key: "NUM_INICIAL",
        },
        {
          label: "Numeração Final",
          key: "NUM_FINAL",
        },
        {
          label: "AR Disponível",
          key: "NUM_DISPONIVEL",
        },
        {
          label: "Quantidade",
          key: "QUANTIDADE",
        },        
        {
          label: "Data Inclusão",
          key: "DATA_INCLUSAO",
        },
        {
          label: "Data Validade",
          key: "DATA_VALIDADE",
        },
        {
          label: "Tipo Postal",
          key: "COD_FAC_AR",
        },
        {
          label: "Tipo FAC",
          key: "TIPO_FAC_AR",
        },
        {
          label: "Data Desativação",
          key: "DATA_DESATIVACAO",
        },
        {
          label: "BM inclusão",
          key: "OPERADOR_INCLUSAO",
        },        
      ],
    };
  },

  methods: {
    verificaPreenchimento() {
      const result =
        this.postagem.numeracaoInicial !== null &&
        this.postagem.numeracaoInicial !== "" &&
        this.postagem.numeracaoFinal !== null &&
        this.postagem.numeracaoFinal !== "" &&
        this.postagem.codFacAR !== null &&
        this.postagem.codFacAR !== "" &&
        this.validade !== null &&
        parseInt(this.validade) !== 0 &&
        this.validade !== "";
      return !result;
    },

    desfazerCancelar() {
      this.fecharModal("modal-cancelar-atualizacao");
    },
    sairModalAtualizacao() {
      this.fecharModal("modal-salvar-atualizacao");
    },

    abrirConfirmacao() {
      this.abrirModal("modal-salvar-atualizacao");
    },

    sairModalCancelamento() {
      this.fecharModal("modal-cancelar-atualizacao");
      this.limparCampos();
      this.mensagemErro = [];
      this.exibeCadastrarNovaFaixa = false;
      this.exibirBtnNovaFaixaPostagem = true;
    },

    persistirDados: async function () {
      this.fecharModal("modal-salvar-atualizacao");
      this.fecharModal("modal-cancelar-atualizacao");
      this.carregando = true;
      this.mensagemErro = [];
      this.mensagemSucesso = [];     
      //
      let dtValidade = this.postagem.dataValidade
        ? new Date(moment(this.postagem.dataValidade).add(3, 'hours').format('YYYY-MM-DD  HH:mm:ss'))
        : null;       
      const dadosPostagem = {
        idfranqueada: this.postagem.idfranqueada,
        tipoFaixa: 1, /// ----> "Local"F
        numeracaoInicial: this.postagem.numeracaoInicial,
        numeracaoFinal: this.postagem.numeracaoFinal,
        numeracaoDisponivel: this.postagem.numeracaoDisponivel,
        dataValidade: dtValidade,
        codFacAR: this.postagem.codFacAR,
        tipoFac: this.postagem.tipoFac,
        matricula: this.userName,
      };
      try {
        await this.$axios
          .post(this.$env.url_backend + constantes.processarNovaFaixaFacAR, {
            dadosPostagem: dadosPostagem,
          })
          .then((response) => {          
            const retorno = response.data;
            this.persistiuOK = retorno == 'OK' ? true : false;
          });
      } catch (error) {  
        const mensagem = normalizaMensagemApi(error);   
        this.persistiuOK = false;
        this.mensagemErro.push(mensagem);        
      }
      //
      
      window.scrollTo(0, 0);
      
      if (this.persistiuOK) {
        this.mensagemSucesso = [];
        this.mensagemErro = [];
        this.mensagemSucesso.push("Atualização efetuada com sucesso.");
      }     
      this.limparCampos();
      this.exibeCadastrarNovaFaixa = false;
      this.exibeHistoricoPostagem = false;
      this.exibirBtnNovaFaixaPostagem = false;  
      this.montaHistoricoPostagem();
      this.carregando = false;
    },

    limparCampos() {
      this.postagem.idfranqueada = "";
      this.postagem.tipoFaixa = "Local";
      this.postagem.numeracaoInicial = "";
      this.postagem.numeracaoFinal = "";
      this.postagem.numeracaoDisponivel = "";
      this.postagem.dataInclusao = "";
      this.postagem.dataValidade = "";
      this.postagem.codFacAR = "FF";
      this.postagem.tipoFac = "D";
      this.validade = "";
      this.quantidade = "";
    },  

    abrirModal: function (referencia) {
      this.$refs[referencia].show();
    },

    fecharModal: function (referencia) {
      this.$refs[referencia].hide();
    },

    calculaQuantidade() {
      this.quantidade =
        this.postagem.numeracaoFinal - this.postagem.numeracaoInicial;
      this.consisteCampos();
    },

    consisteCampos() {
      this.mensagemErro = [];
      this.quantidade =
        this.postagem.numeracaoFinal - this.postagem.numeracaoInicial;
      if (this.quantidade <= 0) {
        this.mensagemErro.push(
          "A numeração Final não pode ser menor ou igual a numeração Inicial."
        );
        this.quantidade = 0;
        window.scrollTo(0, 0);
      }
    },

    salvarInclusao() {
      this.consisteCampos();
      if (this.mensagemErro.length == 0) this.abrirConfirmacao();
    },

    calculaDataValidade(dias) {
      let hoje = new Date();
      hoje.setHours(0, 0, 0, 0); // Garante que a hora está zerada
      // Adicionando dias corretamente usando milissegundos (precisão absoluta)
      let novaData = new Date(hoje.getTime() + dias * 24 * 60 * 60 * 1000);
      let dataFormatada = this.formataData(novaData);
      // Atribuir ao campo
      this.postagem.dataValidade = dataFormatada;
    },

    foramataData(data) {
      //// devolve no formato YYYY-MM-DD
      let ano = data.getFullYear();
      let mes = String(data.getMonth() + 1).padStart(2, "0");
      let dia = String(data.getDate()).padStart(2, "0");
      let dataFormatada = `${ano}-${mes}-${dia}`;
      return dataFormatada;
    },

    preencheNumDisponivel() {
      this.postagem.numeracaoDisponivel = this.postagem.numeracaoInicial;
    },

    async novaFaixaPostagem() {
      this.exibirBtnNovaFaixaPostagem = false;
      this.exibeCadastrarNovaFaixa = true;
      this.postagem.idfranqueada = 10;
    },

    montaDadosExibicao(tabela) {
      this.listaPostagemFaixa = [];
      for (let i = 0, l = tabela.length; i < l; i++) {
        let retList = {};

        retList.DESCRICAO = tabela[i].DESCRICAO;
        switch (tabela[i].TIPO_FAIXA) {
          case 1:
            retList.TIPO_FAIXA = "Local";
            break;
          case 2:
            retList.TIPO_FAIXA = "Estadual";
            break;
          case 3:
            retList.TIPO_FAIXA = "Nacional";
            break;
          default:
            this.carregando = false;
            this.mensagemErro.push("Tipo de faixa inválido");
            break;
        }
        // retList.TIPO_FAIXA = tabela[i].TIPO_FAIXA;
        retList.NUM_INICIAL = tabela[i].NUM_INICIAL;
        retList.NUM_FINAL = tabela[i].NUM_FINAL;
        retList.NUM_DISPONIVEL = tabela[i].NUM_DISPONIVEL;
        retList.DATA_INCLUSAO =
          tabela[i].DATA_INCLUSAO !== null
            ? moment(String(tabela[i].DATA_INCLUSAO)).format("DD/MM/YYYY")
            : null;
        retList.DATA_VALIDADE =
          tabela[i].DATA_VALIDADE !== null
            ? moment(String(tabela[i].DATA_VALIDADE)).format("DD/MM/YYYY")
            : null;
        retList.COD_FAC_AR = tabela[i].COD_FAC_AR;
        retList.QUANTIDADE = tabela[i].NUM_FINAL - tabela[i].NUM_DISPONIVEL;
        retList.TIPO_FAC_AR = tabela[i].TIPO_FAC_AR;
        retList.OPERADOR_INCLUSAO = tabela[i].MATRICULA;
        retList.DATA_DESATIVACAO =
          tabela[i].DATA_DESATIVACAO !== null
            ? moment(String(tabela[i].DATA_DESATIVACAO)).format("DD/MM/YYYY")
            : null;
        this.listaPostagemFaixa.push(retList);
      }
    },

    formataData: function (date) {
      let d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    montaHistoricoPostagem: async function () {
      /// verifica perfil 
      if (this.origemAcesso == "AD") {
          await this.$axios
            .post(this.$env.url_backend + constantes.possuiPermissaoEspecial, {
                 usecase: 'USC.21.020',                        
                 usuario: this.userName.toUpperCase(),           
            })
            .then((response) => {
              this.permissaoAcesso  = response.data;
            })
            .catch((error) => {
                this.permissaoAcesso = false;
                const mensagem = normalizaMensagemApi(error);   
                this.mensagemErro.push(mensagem);                 
            });         
      }

      await this.$axios
        .get(this.$env.url_backend + constantes.consultarFaixaFacAR, {})
        .then((response) => {
          const retorno = response.data;
          const lista = retorno;
          this.montaDadosExibicao(lista);
          this.carregando = false;
          this.exibeHistoricoPostagem = true;
          this.exibirBtnNovaFaixaPostagem = true;
        })
        .catch((error) => {
          const mensagem = normalizaMensagemApi(error);   
          this.mensagemErro.push(mensagem);  
          window.scrollTo(0, 0);
        });
    },    
  },

  async beforeMount() {
    this.userName = this.$store.getters.userInfo.preferred_username;
    this.origemAcesso = this.$store.getters.userInfo.origem;
    this.origemNome = this.$store.getters.userInfo.name;
    this.matriculaOperador = this.userName;
  },

  async mounted() {
    this.carregando = true;
    try {
      this.montaHistoricoPostagem();
      
      this.opcoesFranqueadas = [];

      await this.$axios
        .get(this.$env.url_backend + constantes.buscarFranqueadas, {})
        .then((response) => {
          const options = response.data;
          for (let i = 0, l = options.length; i < l; i++) {
            this.opcoesFranqueadas.push({
              text: options[i].DESCRICAO,
              value: options[i].ID_FRANQUEADA,
              disabled: true,
            });
          }
          this.opcoesFranqueadas.unshift({
            text: "SELECIONE",
            value: "",
            selected: true,
            disabled: true,
            hidden: true,
          });
        })
        .catch((error) => {
          const mensagem = normalizaMensagemApi(error);   
          this.mensagemErro.push(mensagem);  
          window.scrollTo(0, 0);
        });
    } finally {
      this.carregando = false;
    }
  },

  created() {
    this.carregando = false;
  },
};
</script>

<style lang="css" scoped>
.container {
  min-width: 90%;
  max-width: 90%;
}

::v-deep .small-modal .modal-dialog {
  width: 30%;
  max-width: 50%;
}

::v-deep .modal-dialog {
  width: 95%;
  max-width: 100%;
}

hr {
  border-color: #aaa;
  box-sizing: border-box;
  width: 100%;
}

.tooltip .tooltiptext {
  width: 20px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.inner-btn.btn_tam {
  width: 10px;
  height: 20px;
}

.botao {
  width: 150px;
  height: 80px;
}

.inner-btn {
  position: absolute;
  width: 10px;
  font-weight: 550;
  border: none;
  background-color: transparent;
  line-height: 35px;
  left: calc(100% - 30px);
  z-index: 99999;
}

.inner-btn:hover {
  color: blue;
}
</style>

